import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, TextField } from '@mui/material';
import { useController, useFormContext, useForm } from "react-hook-form";

export default function TextInput(props) {
  const { name, onChange, labelAbove, label, fullWidth, onBlur, value, InputProps, inputProps, InputLabelProps, FormHelperTextProps, ...textFieldProps } = props;
  const formContext = useFormContext();
  const fallbackForm = useForm();
  const { control } = formContext ?? fallbackForm; // Fallback if used outside FormProvider
  const {
    field,       // Contains: onChange, onBlur, value, ref
    fieldState: { error }   // Contains: error
  } = useController({ name, control });

  const handleChange = (option) => {
    field.onChange(option.target.value)
    onChange && onChange(option)
  }

  const handleBlur = (event) => {
    field.onBlur(); // Ensures react-hook-form validation runs
    onBlur && onBlur(event); // Calls parent onBlur if provided
  };

  return (
    <FormControl fullWidth={(fullWidth !== undefined) ? fullWidth : true}>
      {labelAbove && <InputLabel className="label-above mw-100 lh-1" htmlFor={props.id}>{label}</InputLabel>}
      <TextField
        {...textFieldProps}
        value={value ?? field.value ?? ""}
        error={!!error}
        onChange={handleChange}
        onBlur={handleBlur}
        helperText={error && error.message}
        variant={props.variant || "filled"}
        label={labelAbove ? undefined : label}
        slotProps={{
          inputLabel: {
            shrink: field.value || props.value? true : undefined, // Ensures label shrinks when there is a value
            ...InputLabelProps,
          },
          input: InputProps,
          htmlInput: inputProps,
          formHelperText: FormHelperTextProps,
        }}
      />
    </FormControl>
  );
}

TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelAbove: PropTypes.bool,
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  variant: PropTypes.string,
};
